import React, { useState } from "react";
import "./SignUp.scss";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { register } from "../../../store/auth/actions";
import Swal from "sweetalert2";

import Form1 from "../../../components/signup/form1/Form1";
import Form2 from "../../../components/signup/form2/Form2";
import Form3 from "../../../components/signup/form3/Form3";
import Form4 from "../../../components/signup/form4/Form4";
import Form5 from "../../../components/signup/form5/Form5";
import Form6 from "../../../components/signup/form6/Form6";
import Form7 from "../../../components/signup/form7/Form7";
import Form8 from "../../../components/signup/form8/Form8";
import Form9 from "../../../components/signup/form9/Form9";
import Form10 from "../../../components/signup/form10/Form10";

const SignUp = (props) => {
  const [secureText, setSecureText] = React.useState(true);
  const [secureText2, setSecureText2] = React.useState(true);
  const [tab, setTab] = React.useState(1);
  const [state, setState] = useState({
    name: "",
    email: "",
    music_genre: "",
    password: "",
    confirmPassword: "",
  });

  return (
    <div className="SignUp">
      <div className="left">
        <img src="/images/bg/sign-up.png" alt="" className="img-fluid" />
      </div>
      <div className="right">
        <div className="form">
          {/* <div className="h1">Sign Up</div> */}
          <div className="w-100">
            {tab === 1 && (
              <Form1
                clicking={() => {
                  setTab(2);
                }}
              />
            )}
            {tab === 2 && (
              <Form10
                clicking={() => {
                  setTab(3);
                }}
              />
            )}
            {tab === 3 && (
              <Form2
                clicking={() => {
                  setTab(4);
                }}
              />
            )}
            {tab === 4 && (
              <Form3
                clicking={() => {
                  setTab(5);
                }}
              />
            )}
            {tab === 5 && (
              <Form4
                clicking={() => {
                  setTab(6);
                }}
              />
            )}
            {tab === 6 && (
              <Form5
                clicking={() => {
                  setTab(7);
                }}
              />
            )}
            {tab === 7 && (
              <Form6
                clicking={() => {
                  setTab(8);
                }}
              />
            )}
            {tab === 8 && (
              <Form7
                clicking={() => {
                  setTab(9);
                }}
              />
            )}
            {tab === 9 && (
              <Form8
                clicking={() => {
                  setTab(10);
                }}
              />
            )}
            {tab === 10 && (
              <Form9
                clicking={() => {
                  props.history.push("/login");
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  loading: state.auth.loading,
  errorMessage: state.auth.errorMessage,
});
export default connect(mapStateToProps, {
  register,
})(SignUp);
